import React from 'react';

import classnames from 'classnames/bind';

import { AdminUsersData } from '@SERVICES';

import useGlobalPermissions from '@HOOKS/useGlobalPermissions';
import useInviteUserModal from '@HOOKS/store/modals/useInviteUserModal';

import AddButton from '@COMPONENTS/COMMON/buttons/AddButton';
import User from '@PAGES/admin/users-permissions/components/User';

import styles from './Content.module.scss';

const cx: CX = classnames.bind(styles);

function Content(props: Props) {
    const { usersData } = props;

    const {
        canManagePermissions,
    } = useGlobalPermissions();

    const {
        actions: inviteUserModalActions,
    } = useInviteUserModal();

    return (
        <div className={cx('content')}>
            <div className={cx('page-name', 'container')}>
                Users permissions
            </div>

            <div className={cx('add-user-button', 'container')}>
                <AddButton
                    locked={!canManagePermissions}
                    title="Invite new user"
                    fontSize={36}
                    onClick={() => {
                        inviteUserModalActions.open();
                    }}
                />
            </div>

            {
                usersData.length > 0
                    ? (
                        <div className="container">
                            <div className={cx('users-list')}>
                                {
                                    usersData.map((user) => {
                                        const key = user.id;

                                        return (
                                            <div
                                                key={key}
                                                className={cx('user-wrapper')}
                                            >
                                                <User user={user} />
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    ) : (
                        <div className={cx('users-not-found', 'container')}>
                            No users
                        </div>
                    )
            }
        </div>
    );
}

type Props = {
    usersData: AdminUsersData,
};

export default React.memo(Content, (prevProps, nextProps) => prevProps.usersData === nextProps.usersData);
